// combine
import combineReducer from "./combineReducer";

// reducer
import commonReducer from "../reducers/commonReducer";
import homeReducer from "../reducers/homeReducer";
import userReducer from "../reducers/userReducer";
import snaReducer from "../reducers/snaReducer";
import gisReducer from "../reducers/gisReducer";
import errorReducer from "../reducers/errorReducer";
import themeReducer from "../reducers/themeReducer";
import digitalAIReducer from "../reducers/digitalAIReducer";

const reducers = combineReducer({
  common: commonReducer,
  home: homeReducer,
  user: userReducer,
  sna: snaReducer,
  gis: gisReducer,
  errorPage: errorReducer,
  theme: themeReducer,
  digitalAI: digitalAIReducer,
});

export default reducers;
